<script>
export default {
  name: "DidoMillesimeInputFilterSelectInList",
};
</script>

<script setup>
import { ref, computed, watch } from "vue";
import { apiValueToLocaleString } from "../../../utils";

// define Props
const props = defineProps({
  modelValue: { type: String, required: false, default: "" },
  availableValues: { type: Array, required: true },
  label: { type: Boolean, required: true },
  type: { type: String, required: true },
});

// define watchers
watch(
  () => [props.modelValue],
  () =>
    (inputValue.value = props.modelValue
      ? props.modelValue.split("$SEPARATOR$")
      : []),
);

// define Emits
const emit = defineEmits(["update:model-value"]);

// computed data to check if it's a number value
const isNumber = computed(() => ["number", "integer"].includes(props.type));

// define reactive data
const inputValue = ref(
  props.modelValue ? props.modelValue.split("$SEPARATOR$") : [],
);

const formatSingle = (val) =>
  val && isNumber.value
    ? String(val).replace(/,/g, ".").replace(/\s/g, "")
    : val;
// define computed value for formatting input value
const formattedValue = computed(() =>
  inputValue.value.map((val) => formatSingle(val)).join("$SEPARATOR$"),
);
</script>

<template>
  <QSelect
    v-model="inputValue"
    dense
    square
    outlined
    multiple
    :label="label ? 'Choisissez des valeurs' : ''"
    stack-label
    class="dido-millesimefilter-multiple"
    :options="
      props.availableValues.map((opt) => ({
        value: opt === null ? '' : String(opt),
        label: apiValueToLocaleString(opt, props.type),
      }))
    "
    @update:model-value="emit('update:model-value', formattedValue)"
  >
    <template #option="{ itemProps, opt, selected, toggleOption }">
      <QItem
        v-bind="itemProps"
        dense
        class="text-small"
        @click="toggleOption(opt.value)"
      >
        <QItemSection>
          <QItemLabel v-html="opt.label" />
        </QItemSection>
        <QItemSection side>
          <QCheckbox
            dense
            color="secondary"
            :model-value="selected"
            @update:model-value="() => toggleOption(opt.value)"
          />
        </QItemSection>
      </QItem>
    </template>
    <template #selected-item="{ removeAtIndex, index, tabindex, opt }">
      <QChip
        removable
        :label="apiValueToLocaleString(opt, props.type)"
        size="sm"
        :tabindex="tabindex"
        color="secondary"
        text-color="black"
        class="text-bold"
        @remove="removeAtIndex(index)"
      />
    </template>
  </QSelect>
</template>

<style lang="sass" scoped>
.dido-millesimefilter-multiple
  min-width: 150px
</style>
